import React, { FC, useCallback, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { CheckBox, SelectBox, TextBox } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { CashFlowItem } from 'bus/cash/cashFlow/types';
import {
  useChangeCashFlowItemMutation,
  useCreateCashFlowItemMutation,
  useLazyGetCashFlowItemDetailQuery,
} from 'bus/cash/services/cashFlowDetail';

type Props = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: CashFlowItem = {
  id: null,
  cashFlowType: null,
  name: '',
  isCalculationProvider: false,
};

const storeTypes = $createStore('/v1/CashFlowItem/types', 'id');

const CashItemAddEditModal: FC<Props> = ({ changeVisible, refresh, visible, id }) => {
  let createFacroryGroupValidationRef = useRef<ValidationGroup>(null);

  const [getCashFlowItemDetail] = useLazyGetCashFlowItemDetailQuery();
  const [createCashFlowItem] = useCreateCashFlowItemMutation();
  const [changeCashFlowItem] = useChangeCashFlowItemMutation();

  const [form, setForm] = useState<CashFlowItem>(initialForm);
  const [itemsTypes, setItemsTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const storeCashFlowTypes: any = useCallback(async () => {
    const result: any = await storeTypes.load();
    setItemsTypes(result);
  }, []);

  const onShown = async () => {
    storeCashFlowTypes();
    if (id) {
      await getCashFlowItemDetail({ id })
        .unwrap()
        .then((data) => setForm(data));
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createFacroryGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();

    if (createFacroryGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeCashFlowItem(form);
      } else {
        await createCashFlowItem({
          cashFlowType: form.cashFlowType,
          name: form.name,
          isCalculationProvider: form.isCalculationProvider,
        });
      }
      changeVisible(false);
      refresh();
    }
    setLoading(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Статьи движения ДС"
        width={400}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createFacroryGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Наименование" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            placeholder="Наименование"
                            mode="text"
                            value={form.name}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, name: e.event.currentTarget.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Наименование" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                        <AppFiledBox label="Тип" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите тип"
                            mode="text"
                            searchExpr={['name']}
                            valueExpr="id"
                            value={form.cashFlowType}
                            onValueChange={(e) => {
                              setForm({ ...form, cashFlowType: e });
                            }}
                            displayExpr="name"
                            items={itemsTypes}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле площадка" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="" labelTop>
                          <CheckBox
                            value={form.isCalculationProvider}
                            text="Расчет с поставщиками"
                            onValueChanged={(e) => setForm((prev) => ({ ...prev, isCalculationProvider: e.value }))}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CashItemAddEditModal;
